var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Cidades","p-read-link":"cities.read.one","p-create-link":"cities.create","p-name":"cities"}})}
var staticRenderFns = []

export { render, staticRenderFns }